import firebaseApp from "../firebase/credenciales";
import {
  deleteDoc,
  doc,
  getFirestore,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import {
  limpiarCoordenadasGrupoDuplicadasUsuario,
  sincronizarMembresiasYCoordenadas,
} from "./gruposSyncService";
import {
  asignarSedeAUsuario,
  quitarSedeDeUsuario,
} from "./coordenadasSedeService";

const db = getFirestore(firebaseApp);

const unique = (arr) =>
  Array.from(new Set((arr || []).filter(Boolean).map((v) => String(v))));

export const syncGroupState = async ({
  rucEmpresa,
  groupId,
  groupName,
  currentMemberDnis,
  currentSedeIds,
  previousMemberDnis,
  previousSedeIds,
  sedesData = [],
  companyName = "Mi Empresa",
}) =>
  sincronizarMembresiasYCoordenadas({
    rucEmpresa,
    groupId,
    groupName,
    currentMemberDnis,
    currentSedeIds,
    previousMemberDnis,
    previousSedeIds,
    sedesData,
    companyName,
  });

export const assignUserMembership = async ({
  rucEmpresa,
  dni,
  previousGroup,
  nextGroup,
  previousSedeIds = [],
  nextSedeIds = [],
  sedesData = [],
  companyName = "Mi Empresa",
}) => {
  const dniStr = String(dni || "");
  if (!rucEmpresa || !dniStr) return;

  const previousGroupId = String(previousGroup?.id || "");
  const nextGroupId = String(nextGroup?.id || "");

  const prevSedes = unique(previousSedeIds);
  const nextSedes = unique(nextSedeIds);

  if (previousGroup && previousGroupId !== nextGroupId) {
    const oldMembersNext = unique(previousGroup.members || []).filter(
      (memberDni) => memberDni !== dniStr
    );
    await updateDoc(doc(db, `grupos/${rucEmpresa}/grupos`, previousGroupId), {
      members: oldMembersNext,
      updatedAt: serverTimestamp(),
    });
  }

  if (nextGroup && previousGroupId !== nextGroupId) {
    const newMembersNext = unique([...(nextGroup.members || []), dniStr]);
    await updateDoc(doc(db, `grupos/${rucEmpresa}/grupos`, nextGroupId), {
      members: newMembersNext,
      updatedAt: serverTimestamp(),
    });
  }

  // Al cambiar de grupo se retira la procedencia del grupo anterior en cada
  // sede que tuviera: el documento se borra solo si ninguna otra procedencia
  // (asignación individual u otro grupo) lo mantiene
  if (previousGroupId) {
    await Promise.all(
      prevSedes.map((sedeId) =>
        quitarSedeDeUsuario({ dni: dniStr, sedeId, grupoId: previousGroupId })
      )
    );
  }

  if (nextGroupId) {
    const membershipRef = doc(db, `grupos/${rucEmpresa}/memberships`, dniStr);
    await setDoc(
      membershipRef,
      {
        rucEmpresa,
        dni: dniStr,
        groupId: nextGroupId,
        groupName: nextGroup?.name || "",
        sedeIds: nextSedes,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    await Promise.all(
      nextSedes.map(async (sedeId) => {
        const sede = sedesData.find((s) => String(s.id) === String(sedeId));
        if (!sede) return;
        // Documento canónico `${dni}_${sedeId}`: la procedencia se acumula, así
        // que reasignar grupo no vuelve a crear un documento para la misma sede
        await asignarSedeAUsuario({
          dni: dniStr,
          ruc: rucEmpresa,
          sede,
          companyName,
          grupoId: nextGroupId,
          grupoNombre: nextGroup?.name || "",
        });
      })
    );
    await limpiarCoordenadasGrupoDuplicadasUsuario({
      dni: dniStr,
      groupId: nextGroupId,
      allowedSedeIds: nextSedes,
    });
  } else {
    await deleteDoc(doc(db, `grupos/${rucEmpresa}/memberships`, dniStr));
  }

  if (previousGroupId) {
    await limpiarCoordenadasGrupoDuplicadasUsuario({
      dni: dniStr,
      groupId: previousGroupId,
      allowedSedeIds: [],
    });
  }
};
